import React from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TopBar from '../components/TopBar';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.white};
`;

const MainContent = styled.main`
  flex: 1;
`;

const MainLayout = ({ children }) => (
  <AppContainer>
    <TopBar />
    <Header />
    <MainContent>
      {children}
    </MainContent>
    <Footer />
  </AppContainer>
);

export default MainLayout;
